export const DEFAULT_CLUSTER_FONT_SIZE = 16;

export const DEFAULT_UNCLUSTERED_POINT_RADIUS = 20;

export { MAP_LAYER } from 'components/Map/constants';

export { LAYER_TYPE } from 'hooks/useMapBox/constants';
